import type { FaireProductEntity } from "../../entity_types/product";

export const p_ch6apwi6mz: FaireProductEntity = {
  token: "p_ch6apwi6mz",
  type: "product",
  name: "Lamare Weekly Planner Notepad \u2013 Tear-Off Desk Pad\u00a0",
  brandName: "Lamare",
  imageUrl:
    "https://cdn.faire.com/fastly/0b20ed0b2143c65f0300bfd8280f8d15c75aa63bdc39ee622d90a4760a3cd8bc.png",
  priceDollars: 8.97,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/683f1e144e07abc3e4c0d40d6ddade2f7dde20ff25c414cceb40291ee8eacc4c.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
